import { withStaticProperties } from "@tamagui/core";
import { Actions } from "./Actions";
import { Content } from "./Content";
import { Dialog as DialogFrame } from "./Dialog";
const Dialog = withStaticProperties(DialogFrame, {
  Content,
  Actions
});
export {
  Dialog
};
